
export class ConstantField {
    public static readonly SERVER: string = '/router/'
    // public static readonly IMAGE_SERVER: string = 'http://39.108.176.22:8085'

    public static readonly TIMEOUT: number = 12 * 1000

    //语言设置key
    public static readonly LANGUAGE_LOCAL_KEY = "language"
}